$.widget("fac.quiz", {

    // Vars
    me: this,               // This class
    quiz: null,             // The html div around the quiz
    quizJson: null,         // All of the json that makes up a quiz

    thisQuizBubble: null,   // The little bubbles that start off a quiz
    completedQuizSets: 0,   // Number of completed quizzes
    transitionTimeout: 2000,// Duration of wait or animation
    previewMode: false,

    questionSet: null,      // Array of questions with this set
    questions: null,        // All questions
    question: null,         // The current question
    questionIndex: 0,       // Index of the clicked answer
    questionNumber: 0,
    questionCount: 0,       // Number of questions in this group

    imageMapCount: 0,       // The amount of points for this map
    imageMapCorrect: [],    // The ones the user has answered already

    lightboxObj: null,      // the object created by the lightbox plugin
    lightboxContent: null,  // The content area within the lightbox
    lightboxFooter: null,   // The footer containing the buttons
    lightboxHeaderH1: null, // The h1 element within the lightbox
    lightboxAlert: null,

    handleBarsTemplates: {  // All of the processed handlebar templates

        group: null,
        imageList: null,
        text: null,
        animation: null,

        footer_group: null,
        footer_question: null,
        answer_footer_wrong: null,
        answer_footer_right: null,
        answer_footer_finished: null,
        final_screen: null,
        alert_reset: null,
        alert_quit: null,

        tickCross: null,
        previewOption: null
    },

    rightWrongTitle: {      // Titles for the correct or wrong screen
        correct:  'Correct!',
        wrong : 'Wrong Answer!'
    },

    youCompletedTitle : "You completed",

    // Helpers

    // Add a delay 
    _sleep : function (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    _changeRevealButtonVisibliity: function (hide) {
        var revealButton = $('.button.button--arrow.modal__next.question-btn.reveal');
        if (hide) {
            revealButton.addClass('button--inactive');
        } else {
            revealButton.removeClass('button--inactive');
        }
    },


    // Called when you click an active spot on the image map
    _allHotSpotsClicked: function (question, correct) {
        //console.log('All hostspots clicked');

        var feedback = question.FeedbackCorrect;

        var obj = {
            FeedbackText: feedback,
            Question: question.Question
        };

        console.log('All hostspots clicked obj : %o', obj);

        if (correct) {
            // Show correct answer title
            this.lightboxHeaderH1.removeClass('failure').addClass('success').text(this.rightWrongTitle.correct);
            this.lightboxFooter.html(this.handleBarsTemplates.answer_footer_right());
        } else {
            // Show wrong answer title
            this.lightboxHeaderH1.removeClass('success').addClass('failure').text(this.rightWrongTitle.wrong);
            this.lightboxFooter.html(this.handleBarsTemplates.answer_footer_wrong());
        }

        // content
        var contentRightWrong = this.handleBarsTemplates.answer_content_right_wrong(obj);
        console.log('contentRightWrong : %o', contentRightWrong);
        this.lightboxContent.html(this.handleBarsTemplates.answer_content_right_wrong(obj));
    },


    _percentagePosition: function (original, size, coord) {
        var percent = parseInt(size / original * 100);
        return parseInt((coord / 100) * percent);
    },
    _hotSpotsReveal: function (feedBack, correct) {
        $.each(this.question.HotspotData, function (i, v) {
            console.log('Reveal hotspot : %o', v.iconLocations);
            var orig = 640; // This is fixed by the crop
            var currentw = $('#imgMap').width();
            var currenth = $('#imgMap').height();

            $.each(v.iconLocations, function (i2, v2) {

                console.log('pin orig : %o', this.p2);

                var pinData = {
                    top: this.p2._percentagePosition(orig, currenth,v2.top),
                    left: this.p2._percentagePosition(orig, currentw, v2.left),
                    img: 'correct_tick'
                };

                console.log('pin resized : %o', pinData);
                $('#image-map-responses').append(this.p2.handleBarsTemplates.tickCross(pinData));
            }.bind({ p2: this.parent }));
            
        }.bind({ parent: this }));

        // Show the last pin then wait a bit before showing the answer text
        setTimeout(function () {
            this.timoutScope._allHotSpotsClicked(this.timoutScope.question, true);
        }.bind({ timoutScope: this }), this.transitionTimeout);
    },

    // Make sure the question lightbox is visible 
    _openLightboxIfNotVisible : function() {
        // if (this.lightboxObj.css('display') !== 'block') {
        //     this.lightboxObj.css('display', 'block');
        // }

        this.lightboxObj.addClass('modal--open');
        $('body').addClass('body--modal-open');
    },

    // Check if the answer given to a question is correct
    _checkAnswer: function (answerIndex) {
        var thisAnswer = this.question.Answers[answerIndex];
        console.log('thisAnswer : %o', thisAnswer);

        this.lightboxContent.find('a[data-answerindex="' + answerIndex + '"] .flash-overlay').addClass('flash-overlay--active').animate({ opacity: 1 }, this.transitionTimeout, function () {
            $(this).removeClass('flash-overlay--active');
            

            // We want a slight delay after the animation finishes?
            if (this.thisAnswer.IsCorrect) {
                // Show correct answer title
                this.parent.lightboxHeaderH1.removeClass('failure').addClass('success').text(this.parent.rightWrongTitle.correct);
                this.parent.lightboxFooter.html(this.parent.handleBarsTemplates.answer_footer_right(this.thisAnswer));
            } else {
                // Show wrong answer title
                this.parent.lightboxHeaderH1.removeClass('success').addClass('failure').text(this.parent.rightWrongTitle.wrong);
                this.parent.lightboxFooter.html(this.parent.handleBarsTemplates.answer_footer_wrong(this.thisAnswer));
            }

            // content
            this.thisAnswer.Question = this.parent.question.Question;
            switch (this.parent.question.QuestionType) {
                case "imageList":
                    this.thisAnswer.Answer = thisAnswer.AnswerAltText;
                    break;
                default:
                    this.thisAnswer.Answer = thisAnswer.Answer;
                    break;
            }
            
            console.log('thisAnswer 2 : %o', thisAnswer);
            this.parent.lightboxContent.html(this.parent.handleBarsTemplates.answer_content_right_wrong(this.thisAnswer));

        }.bind({ parent: this, thisAnswer: thisAnswer }));

    },

    // Called when the swiffy animation completes
    _animationCompleteCallback: function (answerIndex) {
        console.log('_animationCompleteCallback called back');
        document.removeEventListener("animation_done", this._animationCompleteCallback);
        // Disable the next button 
        //$('.modal__footer .page-footer .question-btn.next').css('display', 'inline-flex');

        var thisAnswer = this.question.Answers[answerIndex];
        if (thisAnswer.IsCorrect) {
            // Show correct answer title
            this.lightboxHeaderH1.removeClass('failure').addClass('success').text(this.rightWrongTitle.correct);
            this.lightboxFooter.html(this.handleBarsTemplates.answer_footer_right(thisAnswer));
        } else {
            // Show wrong answer title
            this.lightboxHeaderH1.removeClass('success').addClass('failure').text(this.rightWrongTitle.wrong);
            this.lightboxFooter.html(this.handleBarsTemplates.answer_footer_wrong(thisAnswer));
        }

        // content
        this.lightboxContent.html(this.handleBarsTemplates.answer_content_right_wrong(thisAnswer));
    },

    // The swiffy 
    _checkAnswerAnimation: function (answerIndex) {
        var thisAnswer = this.question.Answers[answerIndex];
        console.log('thisAnswer Animation : %o', thisAnswer);
        var swiffyJSON = JSON.parse(thisAnswer.SwiffyJSON);

        this.lightboxContent.html('<div id="swiffyHolder" style="width: 100%; height: 100%"></div>');

        // Disable the next button 
        //$('.modal__footer .page-footer .question-btn.next').css('display', 'none');

        document.addEventListener("animation_done", function () { this.parent._animationCompleteCallback(answerIndex); }.bind({ parent: this }), false);
        var stage = new swiffy.Stage(document.getElementById('swiffyHolder'), swiffyJSON);
        console.log('swiffy stage : %o', stage);
        stage.start();
    },

    // Local storage stuff
    _refreshQuizStateFromLocalStorage: function (quizId) {

        this.completedQuizSets = 0;

        // This is only defined when called from the create method. 
        if (quizId === null || quizId === undefined) {
            quizId = this.quizJson.QuizId;
        }

        // Get our working quiz data if it exists
        var lsRaw = window.localStorage.getItem(quizId + '_quiz');
        var lsResult = null;
        // On first run this will be null or an empty string
        if (lsRaw !== null && lsRaw !== '') {
            lsResult = JSON.parse(lsRaw);
        }


        // If we have local storage mark the bubbles complete
        if (lsResult !== null) {
            $.each(lsResult, function (i, v) {
                if (v.complete) {
                    this.parent.completedQuizSets++;
                    var thisBubble = this.parent.quiz.find('.bubble.todo[data-questionset="' + v.questionSetId + '"]');
                    thisBubble.removeClass('todo').addClass('complete');
                    thisBubble.find('.status').text(this.parent.youCompletedTitle);
                }
            }.bind({ parent: this }));
        } else {
            this.completedQuizSets = 0;
            this.quiz.find('.bubble.complete').removeClass('complete').addClass('todo').find('.status').text("To do");
        }

        // Set the Completed count in the little header flag
        $('.page-header .completed-sets').text(this.completedQuizSets);

        // Show / Hide the reset button
        if (this.completedQuizSets > 0) {
            $('.reset-progress').css('display', 'block');
        } else {
            $('.reset-progress').css('display', 'none');
        }

    },

    // Mark a quiz as complete
    _completeQuizLocalStorage: function () {

        // Get our working quiz data if it exists
        var lsRaw = window.localStorage.getItem(this.quizJson.QuizId + '_quiz');
        var lsResult = null;
        // On first run this will be null or an empty string
        if (lsRaw !== null && lsRaw !== '') {
            lsResult = JSON.parse(lsRaw);
        }

        var questionSetId = this.questionSet.__qID;
        if (lsResult === null) {
            // Nothing here yet. Create the object
            lsResult = [];
            lsResult.push({ questionSetId: questionSetId, complete: true });
        } else {
            // Does this key already exist
            var index = lsResult.findIndex(x => x.questionSetId === questionSetId);
            if (index === -1) {
                lsResult.push({ questionSetId: questionSetId, complete: true });
            }
        }
        window.localStorage.setItem(this.quizJson.QuizId + '_quiz', JSON.stringify(lsResult));
        console.log("Setting local storage to : %o", lsResult);

        this._refreshQuizStateFromLocalStorage();
    },

    // Reset the completed question sets
    _resetQuiz: function () {
        window.localStorage.removeItem(this.quizJson.QuizId + '_quiz');
        this._refreshQuizStateFromLocalStorage();
    },

    // Question 

    // When done with all questions
    _populate_Question_FinalScreen: function () {
        console.log('"Final screen" : %o', this.questionSet.FinalScreen);
        var fs = this.questionSet.FinalScreen;
        fs.SetName = this.questionSet.Title;

        // Content
        this.lightboxHeaderH1.text(fs.Title);
        this.lightboxContent.html(this.handleBarsTemplates.final_screen(fs));

        // Footer
        this.lightboxFooter.html(this.handleBarsTemplates.answer_footer_finished());

        // Close the popup
        this.thisQuizBubble.removeClass('todo').addClass('complete').find('.status').text(this.youCompletedTitle);

        // Save this to storage
        this._completeQuizLocalStorage();
       
    },
    // Populate the "Group" question type
    _populate_Question_Group: function () {
        console.log('"Group" question : %o', this.question);

        // Content
        this.lightboxHeaderH1.text(this.question.Title);
        this.lightboxContent.html(this.handleBarsTemplates.group(this.question));

        // Footer
        this.lightboxFooter.html(this.handleBarsTemplates.footer_group());
        this._openLightboxIfNotVisible();
    },
    // Populate the "Image list" question type
    _populate_Question_ImageList: function () {
        console.log('"Image list" question : %o', this.question);

        this.lightboxHeaderH1.text(this.questionNumber + " / " + this.questionSet.QuestionCount);
        this.lightboxContent.html(this.handleBarsTemplates.imageList(this.question));

        this.lightboxFooter.html(this.handleBarsTemplates.footer_question());
        this._openLightboxIfNotVisible();
    },
    // Populate the "Text" question type
    _populate_Question_Text: function () {
        console.log('"Text" question : %o', this.question);

        this.lightboxHeaderH1.text(this.questionNumber + " / " + this.questionSet.QuestionCount);
        this.lightboxContent.html(this.handleBarsTemplates.text(this.question));

        this.lightboxFooter.html(this.handleBarsTemplates.footer_question());
        this._openLightboxIfNotVisible();
    },
    // Populate the "Text" question type
    _populate_Question_Animation: function () {
        console.log('"Animation" question : %o', this.question);

        this.lightboxHeaderH1.text(this.questionNumber + " / " + this.questionSet.QuestionCount);
        this.lightboxContent.html(this.handleBarsTemplates.animation(this.question));

        this.lightboxFooter.html(this.handleBarsTemplates.footer_question());
        this._openLightboxIfNotVisible();
    },
    // Populate the "Hotspot" question type
    _populate_Question_Hotspot: function () {
        console.log('"Hotspot" question : %o', this.question);

        this.imageMapCount = this.question.HotspotData.length;       // reset
        this.imageMapCorrect = [];

        // Add this to our object for tracking progress
        this.question.answers = this.imageMapCount;

        // Content
        this.lightboxHeaderH1.text(this.questionNumber + " / " + this.questionSet.QuestionCount);
        this.lightboxContent.html(this.handleBarsTemplates.hotspot(this.question));

        // Footer
        this.lightboxFooter.html(this.handleBarsTemplates.footer_question());
        this._openLightboxIfNotVisible();


        // Wait until the image is fully loaded then apply the image map scale plugin
        
        var $imgMap = $('#imgMap');

        $imgMap.off();
        $('<img />').off('load');

        // Re-attach
        $imgMap.imagesLoaded(function () {
            // images have loaded
            $imgMap.rwdImageMaps();
        }.bind({ parent: this }));


        //$('#imgMap').maphilight({ strokeColor: '000000', strokeWidth: 4, fill: 'ff0000', fillColor: 'ff0000', alwaysOn: true });
    },

    // Generic populate question - Decides what template to render
    _populateQuestion: function (isRetry) {

        if (this.questionSet.Questions.length > 0) {
            this.question = this.questionSet.Questions[this.questionIndex];
        } else {
            alert('No questions available for questions set : ', $p.questionSet);
        }

        console.log('Question type : %o - Question no : %o', this.question.QuestionType, this.questionIndex);

        switch (this.question.QuestionType) {
            case "group":
                this._populate_Question_Group();
                break;
            case "imageList":
                if (!isRetry) { this.questionNumber++; }
                this._populate_Question_ImageList();
                break;
            case "text":
                if (!isRetry) { this.questionNumber++; }
                this._populate_Question_Text();
                break;
            case "animation":
                if (!isRetry) { this.questionNumber++; }
                this._populate_Question_Animation();
                break;
            case "hotspot":
                if (!isRetry) { this.questionNumber++; }
                this._populate_Question_Hotspot();
                break;
            default:
                alert('"' + this.question.QuestionType + '" is not a valid question type');
        }
    },




    // Widget init
    // ==============

    options: {
        quizJSON: null,
        previewMode: false
    },
    // This is the JQuery "Init" type function and gets run when the plugin get called on an element
    _create: function () {
       
        if (this.options.quizJSON === null) {
            alert('Quiz JSON is missing. Pass to the quiz with the following\n { quizJSON: **quizJsonVar** }');
            return;
        }
        this.previewMode = this.options.previewMode;
        if (this.previewMode) {
            console.log("In preview mode");
        }

        this.quiz = $(this.element);
        this.quizJson = this.options.quizJSON;
        this.questions = this.quizJson.QuestionSets;

        this._refreshQuizStateFromLocalStorage(this.options.quizJSON.QuizId);

        console.log('Starting up a new quiz component using the following :\n %o', this.quizJson);

        this.lightboxObj = $('#quizLightbox');
        this.lightboxContent = $('#lightbox-content');
        this.lightboxFooter = $('footer.page-footer');
        this.lightboxHeaderH1 = this.lightboxObj.find('h1');
        this.lightboxAlert = $('#alertLightbox');

        // Init other stuff
        this._initHandleBars();
        this._setUpEvents();

    },

    _initHandleBars: function () {
        this.handleBarsTemplates.imageList = Handlebars.compile(document.getElementById("question-imageList").innerHTML);
        this.handleBarsTemplates.text = Handlebars.compile(document.getElementById("question-text").innerHTML);
        this.handleBarsTemplates.group = Handlebars.compile(document.getElementById("question-group").innerHTML);
        this.handleBarsTemplates.animation = Handlebars.compile(document.getElementById("question-animation").innerHTML);
        this.handleBarsTemplates.hotspot = Handlebars.compile(document.getElementById("question-hotspot").innerHTML);

        this.handleBarsTemplates.footer_group = Handlebars.compile(document.getElementById("question-footer-group").innerHTML);
        this.handleBarsTemplates.footer_question = Handlebars.compile(document.getElementById("question-footer-question").innerHTML);
        this.handleBarsTemplates.answer_footer_finished = Handlebars.compile(document.getElementById("answer-footer-finished").innerHTML);

        this.handleBarsTemplates.answer_content_right_wrong = Handlebars.compile(document.getElementById("answer-content-right-wrong").innerHTML);
        this.handleBarsTemplates.answer_footer_wrong = Handlebars.compile(document.getElementById("answer-footer-wrong").innerHTML);
        this.handleBarsTemplates.answer_footer_right = Handlebars.compile(document.getElementById("answer-footer-right").innerHTML);

        this.handleBarsTemplates.final_screen = Handlebars.compile(document.getElementById("question-FinalScreen").innerHTML);

        this.handleBarsTemplates.alert_quit = Handlebars.compile(document.getElementById("alert-quit").innerHTML);
        this.handleBarsTemplates.alert_reset = Handlebars.compile(document.getElementById("alert-reset").innerHTML);

        this.handleBarsTemplates.tickCross = Handlebars.compile(document.getElementById("question-hotspot-tickCross").innerHTML);

        this.handleBarsTemplates.previewOption = Handlebars.compile(document.getElementById("preview-mode-options").innerHTML);
    },

    _setUpEvents: function () {

        // Click events
        // ====================

        
        $('#preview').on('change', function (e) {

            e.preventDefault();
            var $me = $(e.target);
            console.log("Preview change : ", $me.val());

            this.parent.questionIndex = parseInt($me.val());
            this.parent.questionNumber = 0;
            for (i = 0; i < this.parent.questionIndex; i++) {
                if (this.parent.questionSet.Questions[i].QuestionType !== 'group') {
                    this.parent.questionNumber++;
                }
            }

            
            console.log('Go to question  : %o', this.parent.questionIndex);
            this.parent._populateQuestion();

        }.bind({ parent: this }));

        // Click on one of the bubble for a question set
        this.quiz.on('click', 'a.bubble' ,function (e) {

            e.preventDefault();
            var $p = this.parent;
            var $me = $(e.target);
            this.parent.thisQuizBubble = $me;

            var questionID = $me.attr('data-questionset');
            if (questionID === '' || questionID === undefined || questionID === null) {
                alert('Question does not have a dataset id. Please add it to the question set in umbraco in the id field');
                return;
            }

            // Get our question
            var questionResults = jQuery.grep(this.parent.questions, function (n, i) {
                return n.__qID === questionID;
            });
            if (questionResults.length === 0) {
                alert('The question set "' + questionID + '" contains no question');
                return;
            }

            // Little bit of clean up
            $p.questionIndex = 0;
            $p.questionNumber = 0;
            this.parent.lightboxHeaderH1.removeClass('failure').removeClass('success');


            // Set the proper question set
            $p.questionSet = questionResults[0];
            $p.questionCount = $p.questionSet.Questions.length;

            if (this.parent.previewMode === true) {
                console.log('Draw preview drop down : %o', $p.questionSet);
                $('#preview').html(this.parent.handleBarsTemplates.previewOption($p.questionSet));
            }

            $p._populateQuestion();

        }.bind({ parent: this }));

        // Reset all progress and set the quiz back to default state
        $('.header-content').on('click', '.reset-progress', function (e) {
            e.preventDefault();
            // Show alert lightbox
            this.parent.lightboxAlert.html(this.parent.handleBarsTemplates.alert_reset());
            // this.parent.lightboxAlert.css('display', 'block');
            this.parent.lightboxAlert.addClass('modal--open');
            $('body').addClass('body--modal-open');
        }.bind({ parent: this }));


        // Question lightbox
        // ---------------

        // Group panel next button - NOT the close version
        this.lightboxObj.on('click', '.question-btn.next:not(.close)', function (e) {
            e.preventDefault();
            this.parent.lightboxHeaderH1.removeClass('failure').removeClass('success');

            // Do we have a next question
            console.log("Question Index : %o ,  question count : ", this.parent.questionIndex, this.parent.questionCount - 1);

            // TODO
            if (this.parent.questionIndex === (this.parent.questionCount -1)) {  
                // We have reached the end of this quiz
                this.parent._populate_Question_FinalScreen();
            } else {
                 // Get the next question
                this.parent.questionIndex++;
                console.log('Go to question : %o', this.parent.questionIndex);
                this.parent._populateQuestion();
            }
        }.bind({ parent: this }));

        // Group panel next button - The close version
        this.lightboxObj.on('click', '.question-btn.next.close', function (e) {
            e.preventDefault();
            // Complete this setc
            // this.parent.lightboxObj.css('display', 'none');
            this.parent.lightboxObj.removeClass('modal--open');
            $('body').removeClass('body--modal-open');
        }.bind({ parent: this }));

        // Lightbox close button
        this.lightboxObj.on('click', 'a.quit', function (e) {
            e.preventDefault();

            // Show alert lightbox
            this.parent.lightboxAlert.html(this.parent.handleBarsTemplates.alert_quit({ title: this.parent.questionSet.Title }));

            // this.parent.lightboxAlert.css('display', 'block');
            this.parent.lightboxAlert.addClass('modal--open');

            $('body').addClass('body--modal-open');
        }.bind({ parent: this }));

        // Try again after wrong answer
        this.lightboxObj.on('click', '.question-btn.try-again', function (e) {
            e.preventDefault();
            this.parent.lightboxHeaderH1.removeClass('failure').removeClass('success');
            this.parent._populateQuestion(true);
        }.bind({ parent: this }));

        // Go to the next question in the set
        this.lightboxObj.on('click', '.question-btn.reveal', function (e) {
            e.preventDefault();

            // Hide the button
            this.parent._changeRevealButtonVisibliity(true);

            console.log('Reveal : %o', this.parent.question.QuestionType);

            // Need to know the question type here
            if (this.parent.question.QuestionType === "hotspot") {
                //console.log("Do hotspot reveal");
                this.parent._hotSpotsReveal();
            } else if (this.parent.question.QuestionType === "animation") {
                //console.log("Do animation reveal");
                var indexAni = this.parent.question.Answers.findIndex(x => x.IsCorrect === true);
                //console.log("Do animation reveal : %o", indexAni);
                this.parent._checkAnswerAnimation(indexAni);
            } else {
                // Call check answer but pass in the correct index
                var index = this.parent.question.Answers.findIndex(x => x.IsCorrect === true);
                this.parent._checkAnswer(index);
            }
        }.bind({ parent: this }));

        // An image answer for the image and text question set
        this.lightboxObj.on('click', 'a.image-question-answer, a.text-question-answer, a.animation-question-answer', function (e) {

            e.preventDefault();
            var $me = $(e.target);
            var thisanswerIndex = $me.attr('data-answerIndex');

            // Hide the button
            this.parent._changeRevealButtonVisibliity(true);

            switch (this.parent.question.QuestionType) {
                case "animation":
                    this.parent._checkAnswerAnimation(parseInt(thisanswerIndex));
                    break;

                default:
                    this.parent._checkAnswer(parseInt(thisanswerIndex));
                    break;
            }

            //console.log('Clicked an image question answer : %o', thisanswerIndex);
            
        }.bind({ parent: this }));

        // An image map area
        this.lightboxObj.on('click', 'map area.hotspot', function (e) {
            e.preventDefault();
            var $me = $(e.target);

            var thisanswerIndex = parseInt($me.attr('data-answerIndex'));
            if (this.parent.imageMapCorrect.includes(thisanswerIndex)) {
                console.log("You clicked this one already!");
            } else {
                // They got one that's not been clicked yet
                // Find the pin data for this set of answers
                var pins = this.parent.question.HotspotData[thisanswerIndex].iconLocations;
                this.parent.imageMapCorrect.push(thisanswerIndex);
                var answeredQuestionCount = this.parent.imageMapCorrect.length;

                // Update the wee progress indicator
                $('.answersCorrectCount .answered').text(answeredQuestionCount);

                var orig = 640; // This is fixed by the crop
                var currentw = $('#imgMap').width();
                var currenth = $('#imgMap').height();

                // Create a pin and render it
                $.each(pins, function (i, v) {

                    console.log('pin orig : %o', v);

                    var pinData = {
                        top: this.p2._percentagePosition(orig, currenth, v.top),
                        left: this.p2._percentagePosition(orig, currentw, v.left),
                        img: 'correct_tick'
                    };

                    console.log('pin resized : %o', pinData);



                    $('#image-map-responses').append(this.p2.handleBarsTemplates.tickCross(pinData));
                }.bind({ p2: this.parent }));

                // Are all the questions answered?
                if (this.parent.imageMapCount === answeredQuestionCount) {
                    // Show the last pin then wait a bit before showing the answer text
                    setTimeout(function () {
                        this.timoutScope._allHotSpotsClicked(this.timoutScope.question, true);
                    }.bind({ timoutScope: this.parent }), this.parent.transitionTimeout);
                }

            }
        }.bind({ parent: this }));
        // The actual image map image. If we get a click here it means they have missed the hotspots
        this.lightboxObj.on('click', 'img#imgMap', function (event) {
            event.preventDefault();
            var $me = $(event.target);
            // Get the image
            var thisEle = document.getElementById('imgMap');
            // Get the bounds for the image we are mapping onto
            bounds = thisEle.getBoundingClientRect();

            // Do we want this or should we save correct between wrong answers?
            this.parent.imageMapCount = 0;       // reset
            this.parent.imageMapCorrect = [];

            var halfImage = 15;
            var left = parseInt(bounds.left);
            var top = parseInt(bounds.top);
            var x = parseInt(event.pageX - left) - halfImage;
            var y = parseInt(event.pageY - top) - window.scrollY - halfImage;
            if (x < 0) x = 0;
            if (y < 0) y = 0;

            var pinData = {
                top: y,
                left: x,
                img: 'incorrect_cross'
            };

            $('#image-map-responses').append(this.parent.handleBarsTemplates.tickCross(pinData));

            // Show the last pin then wait a bit before showing the answer text
            setTimeout(function () {
                this.timoutScope._allHotSpotsClicked(this.timoutScope.question.FeedbackWrong, false);
            }.bind({ timoutScope: this.parent }), this.parent.transitionTimeout);

        }.bind({ parent: this }));


        // Reset quiz button
        this.lightboxObj.on('click', '.page-header.home', function (e) {
            e.preventDefault();

            // this.parent.lightboxObj.css('display', 'none')
            this.parent.lightboxObj.removeClass('modal--open');
            $('body').removeClass('body--modal-open');
        }.bind({ parent: this }));


        // Alert lightbox
        // ---------------

        // Close - Used for the don't quit button as well
        this.lightboxAlert.on('click', '.remodal-close, .cancel.button-modal', function (e) {
            e.preventDefault();
            // this.parent.lightboxAlert.css('display', 'none');
            this.parent.lightboxAlert.removeClass('modal--open');
            // $('body').removeClass('body--modal-open');
        }.bind({ parent: this }));

        // Quit button
        this.lightboxAlert.on('click', '.confirm.button-modal.quit', function (e) {
            e.preventDefault();
            // this.parent.lightboxAlert.css('display', 'none');
            // this.parent.lightboxObj.css('display', 'none');
            this.parent.lightboxAlert.removeClass('modal--open');
            this.parent.lightboxObj.removeClass('modal--open');
            $('body').removeClass('body--modal-open');
            
        }.bind({ parent: this }));

        // Reset quiz button
        this.lightboxAlert.on('click', '.confirm.button-modal.reset', function (e) {
            e.preventDefault();
            this.parent._resetQuiz();
            // this.parent.lightboxAlert.css('display', 'none');
            // this.parent.lightboxObj.css('display', 'none');
            this.parent.lightboxAlert.removeClass('modal--open');
            this.parent.lightboxObj.removeClass('modal--open');
            $('body').removeClass('body--modal-open');
        }.bind({ parent: this }));
    }

});


Handlebars.registerHelper('isNotGroup', function (v1, options) {
    if (v1 !== "group") {
        return options.fn(this);
    }
    return options.inverse(this);
});

Handlebars.registerHelper("stripHtmlTags", function (txt) {
    var div = document.createElement("div");
    div.innerHTML = txt;
    var text = div.textContent || div.innerText || "";
    return text;
});

